module.exports = __webpack_public_path__ + "img/game-banner-image-en.84e8b144.png";